import script from "./GabAgendaPrefeitoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GabAgendaPrefeitoPage.vue?vue&type=script&setup=true&lang=js"

import "./GabAgendaPrefeitoPage.vue?vue&type=style&index=0&id=586f35a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586f35a4"]])

export default __exports__